import React from "react";
import { Container, Text } from "components/common";
import { formatNumber } from "utils";

const UserRewardPoints = ({ user }) => {
  return (
    <div className="flex flex-col w-full my-3 md:flex-row">
      <Container
        paddingVertical={0}
        paddingHorizontal={0}
        className="w-full flex-1 h-full justify-center"
      >
        <div className="py-5 md:py-3 px-8 text-center flex flex-col justify-center items-center">
          <h2 className="font-bold text-2xl">Current points</h2>
          <Text className="md:leading-tight text-5xl font-light text-green-primary">
            {formatNumber(user?.rewards?.available_points) || 0}
          </Text>
          <div className="inline-block whitespace-nowrap">
            <Text size="text-sm" className="inline text-gray-primary">
              {"Pending Points: "}
            </Text>
            <Text size="text-sm" className="inline text-gray-primary">
              {formatNumber(user?.rewards?.pending_points) || 0}
            </Text>
          </div>
        </div>
      </Container>
    </div>
  );
};

export default UserRewardPoints;
